export default {
  plano: state => state.plano,
  faturas: stage => stage.faturas
}
